export default __webpack_public_path__ + "static/media/cover.be425e8d.png";